import React from "react";
import styled from "styled-components";
import { Typography } from "@mui/material";

const QuestionText = styled(Typography)`
  color: darkgrey;
  font-size: 13px;
  font-weight: 400;
`;

const AnswerText = styled(Typography)`
  font-size: 14px;
  color: black;
  font-weight: 500;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 0px 4px;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 52px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const Basics = ({ details }) => (
  <>
    <Wrapper>
      <Container>
        <QuestionText> Name </QuestionText>
        <AnswerText>{details.name}</AnswerText>
      </Container>
      <Container>
        <QuestionText>Description</QuestionText>
        <AnswerText variant="subtitle1">
          {details.description ? details.description : "None"}
        </AnswerText>
      </Container>
      <Container>
        <QuestionText variant="body2" color="inherit">
          Disclaimer
        </QuestionText>
        <AnswerText variant="subtitle1">
          {details.disclaimer ? details.disclaimerText : "None"}
        </AnswerText>
      </Container>
      <Container>
        <QuestionText variant="body2" color="inherit">
          Start Date
        </QuestionText>
        <AnswerText variant="subtitle1">
          {details.startDate ? details.startDate : "None"}
        </AnswerText>
      </Container>
      <Container>
        <QuestionText variant="body2" color="inherit">
          End Date
        </QuestionText>
        <AnswerText variant="subtitle1">
          {details.dueDate ? details.dueDate : "None"}
        </AnswerText>
      </Container>
      <Container>
        <QuestionText variant="body2" color="inherit">
          Estimated Time To Complete
        </QuestionText>
        <AnswerText variant="subtitle1">
          {details.estimatedTime} minutes
        </AnswerText>
      </Container>
      <Container>
        <QuestionText variant="body2" color="inherit">
          Show Incorrect Answers
        </QuestionText>
        <AnswerText variant="subtitle1">
          {details.displayAnswers ? "Yes" : "No"}
        </AnswerText>
      </Container>
    </Wrapper>
  </>
);

export default Basics;
